// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {Switch, Route} from 'react-router-dom'
import {VerimatrixLogo} from '../../media/exports'
import history from '../../history'
import {withRouter} from 'react-router'

import {MULTIDRM_PATH, multiDRMNavOptions} from '../MenuItem/MultiDRM/navigation'
import {ANALYTICS_PATH, analyticsNavOptions} from '../MenuItem/Analytics/navigation'

import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined'

import './index.css'

class MainHeader extends Component {

  renderNavOptions () {
    const location = this.props.location.pathname

    return (
      <Switch>
        <Route path={`/${ANALYTICS_PATH}/`} render={() => analyticsNavOptions(location)}/>
        <Route path={`/${MULTIDRM_PATH}/`} render={() => multiDRMNavOptions(location)}/>
      </Switch>
    )
  }

  render () {
    return (
      <div className='main-header container-fluid'>
        <div className='row'>
          <div className='col-lg-6 col-md-5 col-3 left-header'>
            <img src={VerimatrixLogo} alt='Verimatrix Logo' className='vmx-logo' onClick={() => {history.push('/multi-drm/')}}/>
          </div>
          <div className='col-lg-6 col-md-7 col-9 right-header'>
            {this.renderNavOptions()}
            <ul>
              <li className='nav-item'>
                <a href='https://news.verimatrix.com/acton/fs/blocks/showLandingPage/a/4253/p/p-011e/t/page/fm/0' target='_blank' rel='noopener noreferrer'>
                  <ContactSupportOutlinedIcon/>Support
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}


export default withRouter(MainHeader)
